import React from 'react'
import CipherContainer from "./CipherContainer";
import { useNavigate } from 'react-router-dom';
import logo from '../logo.png'

const substitutionalCiphers1 = [
    {
        id: "1",
        name: "Caesar Cipher",
        description: "The Caesar cipher is a simple encryption technique that was used by Julius Caesar to send secret messages to his allies. It works by shifting the letters in the plaintext message by a certain number of positions, known as the “shift” or “key”.",
        bgColor: "#3a86ff",
        path: '/caesarcipher',
    },
    {
        id: "2",
        name: "Multiplicative Cipher",
        description: "A multiplicative cipher is a type of cipher that comes under a monoalphabetic cipher, in which each letter that is present in the plaintext is replaced by a corresponding letter of the ciphertext, according to a fixed multiplication key.",
        bgColor: "#ff006e",
        path: '/multiplicativecipher',
    },
    {
        id: "3",
        name: "Playfair Cipher",
        description: "The Playfair cipher was the first practical digraph substitution cipher. The scheme was invented in 1854 by Charles Wheatstone but was named after Lord Playfair who promoted the use of the cipher.",
        bgColor: "#FFA732",
        path: '/playfaircipher',
    },
]

const substitutionalCiphers2 = [
    {
        id: "1",
        name: "Vernam Cipher",
        description: "The Vernam Cipher, also known as the one-time pad, is a cryptographic technique that provides perfect secrecy when used correctly. It was invented by Gilbert Vernam in 1917. The key feature of the Vernam Cipher is its use of a randomly generated key that is at least as long as the plaintext message and is used only once. This key is truly random and must never be reused.",
        bgColor: "#fb5607",
        path: '/vernamcipher',
    },
    {
        id: "2",
        name: "Vigenere Cipher",
        description: "Vigenere Cipher is a method of encrypting alphabetic text. It uses a simple form of polyalphabetic substitution. A polyalphabetic cipher is any cipher based on substitution, using multiple substitution alphabets. The encryption of the original text is done using the Vigenère square or Vigenère table.",
        bgColor: "#8338ec",
        path: '/vigenerecipher',
    },
]

const transpositionalCiphers = [
    {
        id: "1",
        name: "Keyed Transposition",
        description: "Keyed transposition ciphers operate on the principle of rearranging the order of characters in a plaintext message based on a predetermined key.",
        bgColor: "#ff006e",
        path: '/keyedtransposition',
    },
    {
        id: "2",
        name: "Keyless Transposition",
        description: "The KeyLess Transposition Cipher technique is a simple form of transposition cipher, it is also called as rail fence technique . It’s a type of cryptographic algorithm that rearranges the positions of the letters in a message to create a new, seemingly unrelated message. The technique gets its name from the way we write the message. Applying the rail fence technique in a given text results in a zigzag pattern, with each letter in a row written out before moving to the next row.",
        bgColor: "#3a86ff",
        path: '/keylesstransposition',
    },
]

const Home = () => {

    const navigate = useNavigate();

    return (
        <div className="App">
            <div style={{marginBottom:"20px", display:"flex", justifyContent:"start", textAlign:"start"}}>
                <img src={logo} alt='Logo' width={150} height={70} style={{ display: "inline", margin: 0 }}></img>
                <p className='sim_title'>Encryption Cipher Simulator</p>
            </div>
            
            <div className="grad1" style={{ width: "100%", paddingTop: "10px", paddingBottom: "10px", borderRadius: "10px", backgroundColor: "#0079FF"}} >
                <p className="bold" style={{ textAlign: "center", color:"white", fontSize: "35px" }}>Substitutional Ciphers</p>
            </div>
            

            <div style={{ margin: "10px auto", display: "flex", justifyContent: "center" }}>
                {substitutionalCiphers1.map((task) => (
                    <CipherContainer key={Math.random()} name={task.name} bgColor={task.bgColor} description={task.description} onClick={()=>{navigate(task.path)}} />
                ))}
            </div>

            <div style={{ margin: "10px auto", display: "flex", justifyContent: "center" }}>
                {substitutionalCiphers2.map((task) => (
                    <CipherContainer key={Math.random()} name={task.name} bgColor={task.bgColor} description={task.description} onClick={()=>{navigate(task.path)}} />
                ))}
            </div>

            <div className="grad2" style={{ width: "100%", paddingTop: "10px", paddingBottom: "10px", borderRadius: "10px", backgroundColor: "#0079FF" }} >
                <p className="bold" style={{ textAlign: "center", color: "white", fontSize: "35px" }}>Transpositional Ciphers</p>
            </div>
            <div style={{ margin: "10px auto", display: "flex", justifyContent: "center" }}>
                {transpositionalCiphers.map((task) => (
                    <CipherContainer key={Math.random()} name={task.name} bgColor={task.bgColor} description={task.description} onClick={()=>{navigate(task.path)}} />
                ))}
            </div>
        </div>
    );
}

export default Home